import { useState, useMemo, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import ProductListing from './productListing';
import PriceListing from './priceListing';
import { priceInputData, productInputData } from '../../shared/constants';
import apiServices from '../../services/service';
import { toast } from 'react-toastify';
import { getGridDataByModuleKey } from '../../redux/selector';
import Loader from '../../shared/component/Loader';
import { useSelector } from 'react-redux';

export const Products = () => {
  const containerStyle = useMemo(() => ({ width: '100%', height: '100%' }), []);
  const navigate = useNavigate();
  const location = useLocation();
  const [isTabActive, setIsTabActive] = useState('products');
  const gridDataProduct = useSelector(getGridDataByModuleKey('productList'));
  const gridDataPriceSheet = useSelector(getGridDataByModuleKey('priceSheetList'));
  const [loading, setLoading] = useState(false);

  const isProducts = isTabActive === 'products';
  const prodCount = gridDataProduct?.totalCount;
  const priceCount = gridDataPriceSheet?.totalCount;

  useEffect(() => {
    if (location.pathname.includes('/priceSheet')) {
      setIsTabActive('priceSheet');
    } else if (location.pathname.includes('/productList')) {
      setIsTabActive('products');
    }
  }, [location.pathname]);

  const handleIsTabActive = (tab) => {
    if (tab === 'priceSheet' && location.pathname !== '/products/priceSheet') {
      navigate('/products/priceSheet');
    } else if (tab === 'products' && location.pathname !== '/products/productList') {
      navigate('/products/productList');
    }
    setIsTabActive(tab);
  };

  const handleCreatePriceList = () => {
    navigate('/products/priceSheet/createPriceSheet');
  };

  const handleCreateProduct = () => {
    navigate('/products/productList/createProduct');
  };

   const exportAllProduct = async () => {
      setLoading(true);

      // Ensure filterJson is considered
      const fetchData = {
        ...productInputData,
        pageSize: gridDataProduct?.totalCount,
        searchText: gridDataProduct?.inputPayload?.searchText ? gridDataProduct?.inputPayload?.searchText : null,
        filterJson: gridDataProduct?.inputPayload?.filterJson ? gridDataProduct?.inputPayload?.filterJson : null,
      };

      try {
        const response = await apiServices.exportAllProduct(fetchData);

        if (response?.data && response.status === 200) {
          setLoading(false);
          // const responseText = typeof response.data === "string" ? response.data.trim() : "";

          if (response?.data.includes('Export initiated.')) {
            toast.warning(response?.data); // Show toast
            setLoading(false);
          } else {
            // Convert data to Blob for better handling
            const blob = new Blob([response.data], {
              type: 'text/csv;charset=utf-8;',
            });
            const url = URL.createObjectURL(blob);

            // Create and trigger download
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Products.csv');
            document.body.appendChild(link);
            link.click();

            // Cleanup
            document.body.removeChild(link);
            URL.revokeObjectURL(url); // Free memory
          }
        } else {
          console.error('No data received from API.');
          setLoading(false);
        }
      } catch (error) {
        console.error('Error exporting Invoices:', error);
        setLoading(false);
      }
    };

    const exportAllPriceSheet = async () => {
      setLoading(true);

      // Ensure filterJson is considered
      const fetchData = {
        ...priceInputData,
        pageSize: gridDataPriceSheet?.totalCount,
        searchText: gridDataPriceSheet?.inputPayload?.searchText ? gridDataPriceSheet?.inputPayload?.searchText : null,
        filterJson: gridDataPriceSheet?.inputPayload?.filterJson ? gridDataPriceSheet?.inputPayload?.filterJson : null,
      };

      try {
        const response = await apiServices.exportAllPriceSheet(fetchData);

        if (response?.data && response.status === 200) {
          setLoading(false);
          // const responseText = typeof response.data === "string" ? response.data.trim() : "";

          if (response?.data.includes('Export initiated.')) {
            toast.warning(response?.data); // Show toast
            setLoading(false);
          } else {
            // Convert data to Blob for better handling
            const blob = new Blob([response.data], {
              type: 'text/csv;charset=utf-8;',
            });
            const url = URL.createObjectURL(blob);

            // Create and trigger download
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Price Sheets.csv');
            document.body.appendChild(link);
            link.click();

            // Cleanup
            document.body.removeChild(link);
            URL.revokeObjectURL(url); // Free memory
          }
        } else {
          console.error('No data received from API.');
          setLoading(false);
        }
      } catch (error) {
        console.error('Error exporting Invoices:', error);
        setLoading(false);
      }
    };

  return (
    <>
      {loading && <Loader />}
      <div className="inner-page gos-leads gos-products" style={containerStyle}>
        <div className="dash-container">
          <div className="tbl_container">
            <div className="row">
              <div className="col-12 col-sm-12 col-md-12">
                {/* GrowthOS header */}
                <div className="main-hd">
                  <div className="gos-lead-head">
                    <div className="pagetitle">Products</div>
                    <div className="gos-page-sub">
                      {(prodCount !== undefined ? Number(prodCount).toLocaleString() : '0')} products
                      {' · '}
                      {(priceCount !== undefined ? Number(priceCount).toLocaleString() : '0')} price sheets
                    </div>
                  </div>

                  <div className="third-div gos-lead-actions">
                    <button
                      type="button"
                      className="gos-btn gos-btn-ghost"
                      onClick={isProducts ? exportAllProduct : exportAllPriceSheet}
                    >
                      <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"><path d="M12 3v12M7 10l5 5 5-5M5 21h14" /></svg>
                      Export
                    </button>
                    <button
                      type="button"
                      className="gos-btn gos-btn-primary"
                      onClick={isProducts ? handleCreateProduct : handleCreatePriceList}
                    >
                      <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"><path d="M12 5v14M5 12h14" /></svg>
                      {isProducts ? 'Create Product' : 'Create Price Sheet'}
                    </button>
                  </div>
                </div>

                {/* GrowthOS page-level tab bar — Products / Price Sheet (styling only; tab logic unchanged) */}
                <div className="gos-camptabs">
                  <button
                    type="button"
                    className={'gos-camptabs-tab' + (isProducts ? ' active' : '')}
                    onClick={() => handleIsTabActive('products')}
                  >
                    <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="7" height="7" rx="1" /><rect x="14" y="3" width="7" height="7" rx="1" /><rect x="3" y="14" width="7" height="7" rx="1" /><rect x="14" y="14" width="7" height="7" rx="1" /></svg>
                    Products
                    {prodCount !== undefined && <span className="count">{Number(prodCount).toLocaleString()}</span>}
                  </button>
                  <button
                    type="button"
                    className={'gos-camptabs-tab' + (!isProducts ? ' active' : '')}
                    onClick={() => handleIsTabActive('priceSheet')}
                  >
                    <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82Z" /><circle cx="7" cy="7" r="1.4" /></svg>
                    Price Sheet
                    {priceCount !== undefined && <span className="count">{Number(priceCount).toLocaleString()}</span>}
                  </button>
                </div>

                {isProducts ? <ProductListing /> : <PriceListing />}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Products;
